import type {
  Exercise,
  ExerciseCollection,
} from "@/components/workouts/workoutsColumns";
import { v4 as uuidv4 } from "uuid";

export function exercisesToExerciseCollection(
  exercises: any[]
): ExerciseCollection[] {
  const sorted = [...exercises].sort(
    (a, b) =>
      (a.ex_order ?? 0) - (b.ex_order ?? 0) ||
      (a.sub_order ?? 0) - (b.sub_order ?? 0),
  );

  // A superset shares ex_order inside one section. The same index in another
  // section is a different exercise, not a partner.
  const exerciseCollection: ExerciseCollection[] = [];
  for (const exercise of sorted) {
    const order = exercise.ex_order ?? 0;
    const sectionId = exercise.section_id ?? null;
    const current = exerciseCollection[exerciseCollection.length - 1];
    const sameGroup =
      current != null &&
      (current[0]?.ex_order ?? 0) === order &&
      (current[0]?.section_id ?? null) === sectionId;
    const next = { ...(exercise as Exercise), sortableId: uuidv4() };
    if (sameGroup && current) {
      current.push(next);
    } else {
      exerciseCollection.push([next]);
    }
  }

  return exerciseCollection;
}
